import { createFileRoute, redirect } from "@tanstack/react-router";
import { PageHeader, DataCard, StatusPill } from "@/components/admin/AdminPrimitives";
import { Plug } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

/** SDE.4 · Onda 4.4 — /admin/integracoes exige admin_full quando rbac_enforced=true. */
export const Route = createFileRoute("/_authenticated/admin/integracoes")({
  head: () => ({ meta: [{ title: "Integrações — Admin" }, { name: "robots", content: "noindex, nofollow" }] }),
  beforeLoad: async () => {
    const [{ data: flag }, { data: level }] = await Promise.all([
      supabase.from("feature_flags").select("enabled").eq("key", "rbac_enforced").maybeSingle(),
      supabase.rpc("current_admin_level"),
    ]);
    if (flag?.enabled === true && level !== "full") throw redirect({ to: "/admin" });
  },
  component: () => {
    const items = [
      { name: "Asaas", desc: "Gateway de pagamentos PIX e Cartão.", tone: "green" as const, status: "Conectado" },
      { name: "Supabase", desc: "Banco, autenticação e RLS.", tone: "green" as const, status: "Conectado" },
      { name: "Lovable AI", desc: "IA para insights automáticos.", tone: "green" as const, status: "Conectado" },
      { name: "Stripe", desc: "Cobrança internacional.", tone: "gray" as const, status: "Não configurado" },
      { name: "Google Analytics", desc: "Tráfego e comportamento.", tone: "gray" as const, status: "Não configurado" },
      { name: "E-mail transacional", desc: "Envios automáticos aos membros.", tone: "gold" as const, status: "Pendente" },
    ];
    return (
      <div>
        <PageHeader title="Integrações" description="Conexões com serviços externos." />
        <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
          {items.map((it) => (
            <DataCard key={it.name}>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--gray-soft)] text-[var(--navy)]">
                    <Plug size={16} />
                  </span>
                  <StatusPill tone={it.tone}>{it.status}</StatusPill>
                </div>
                <h3 className="mt-3 font-display text-base font-extrabold text-[var(--navy)]">{it.name}</h3>
                <p className="mt-1 text-sm text-[var(--gray-ink)]">{it.desc}</p>
              </div>
            </DataCard>
          ))}
        </div>
      </div>
    );
  },
});
